/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface WithExpiresOn
 */
export interface WithExpiresOnOptional {
  /**
   * Timestamp when this line item expires and should be automatically removed
   * @type {string}
   * @memberof WithExpiresOn
   */
  expiresOn?: Date;
}

export interface WithExpiresOn extends WithExpiresOnOptional {
  /**
   * Timestamp when this line item expires and should be automatically removed
   * @type {string}
   * @memberof WithExpiresOn
   */
  expiresOn?: Date;
}

export interface WithExpiresOnTrackedI {
  /**
   * Timestamp when this line item expires and should be automatically removed
   * @type {string}
   * @memberof WithExpiresOn
   */
  expiresOn?: Date;
  expiresOnIsSet: boolean;
}

transformDatesMap.set("WithExpiresOn", function (model: WithExpiresOn) {
  if (typeof model.expiresOn == "string")
    model.expiresOn = new Date(model.expiresOn);
});

export type WithExpiresOnMetaI = MetaType<{
  //isDate: false
  //isDatetime: true
  expiresOn: PropertyMeta<MetaTypeBase<Date>>;
}>;

export var WithExpiresOnMeta: WithExpiresOnMetaI = {} as WithExpiresOnMetaI;
WithExpiresOnMeta = typeMeta("WithExpiresOn", {
  expiresOn: propertyMeta("expiresOn", false, false, false, MetaTypesBase.Date),
});

const metaI = WithExpiresOnMeta;

registerMeta(() => {});

export class WithExpiresOnTracked implements WithExpiresOnTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  expiresOn__I?: Date = undefined;
  expiresOnIsSet: boolean = false;
  set expiresOn(v: undefined | Date) {
    if (v !== undefined) {
      this.expiresOn__I = v;
      this.expiresOnIsSet = true;
    } else {
      this.expiresOn__I = v || undefined;
      this.expiresOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get expiresOn() {
    return this.expiresOn__I;
  }
  constructor(config?: WithExpiresOnOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: WithExpiresOnOptional,
    options?: AssignOptions,
  ): WithExpiresOnTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.expiresOn && this.expiresOnApplyFilter(optionsRequired.filter)) {
      this.expiresOn = config.expiresOn;
      if (optionsRequired.unassign) this.expiresOnIsSet = false;
      else this.expiresOnIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): WithExpiresOnTrackedI {
    const cloned = {} as WithExpiresOnTrackedI;
    if (
      this.expiresOnIsSetDeep() &&
      this.expiresOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.expiresOnIsSet = true;
      cloned.expiresOn = this.expiresOn;
    } else {
      //cloned.expiresOnIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): WithExpiresOnTrackedI {
    if (!this.expiresOnApplyFilter(filter)) this.expiresOnIsSet = false;

    return this;
  }
  expiresOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WithExpiresOnMeta.expiresOn,
      WithExpiresOnMeta,
      this.expiresOn,
      this,
    );
  }
  expiresOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.expiresOnIsSet && this.expiresOnApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.expiresOnIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
